export default __webpack_public_path__ + "static/media/logo6.ab705939.png";